import React, {useState, useEffect} from "react";
import styles from "./Main.module.scss";
import {useModal} from "../../context/ModalContext";
import {useResponseStatus} from "../../context/ResponseStatusContext";

// Динамическая загрузка компонентов
const About = React.lazy(() => import("../Sections/About/About"));
const ServicesELS = React.lazy(() => import("../Sections/ServicesELS/ServicesELS"));
const Products = React.lazy(() => import("../Sections/Products/Products"));
const ModalServiceDescriptions = React.lazy(() => import("../Modals/ModalServiceDescriptions"));
const ModalServicesForms = React.lazy(() => import("../Modals/ModalServicesForms"));
const ModalC = React.lazy(() => import("../../components/Modals/ModalC"));
const ExpertsSlider = React.lazy(() => import("../Sections/ExpertsSlider/ExpertsSlider"));
const Technologies = React.lazy(() => import("../Sections/Technologies/Technologies"));
const AutoServices = React.lazy(() => import("../Sections/AutoServices/AutoServices"));
const PlatformsTop = React.lazy(() => import("../Sections/Platforms/PlatformsTop"));
const CoreValues = React.lazy(() => import("../Sections/CoreValues/CoreValues"));
const Reviews = React.lazy(() => import("../Sections/Reviews/Reviews"));
const Partners = React.lazy(() => import("../Sections/Partners/Partners"));
const Awards = React.lazy(() => import("../Sections/Awards/Awards"));
const OurMission = React.lazy(() => import("../Sections/OurMission/OurMission"));
const PlatformsBottom = React.lazy(() => import("../Sections/Platforms/PlatformsBottom"));

const Main: React.FC = () => {
    const {openModalC, closeModals} = useModal();
    const {setFormType, setResponseStatus} = useResponseStatus();
    const [modalInitialized, setModalInitialized] = useState(false);

    useEffect(() => {
        if (!modalInitialized) {
            if (window.location.href.indexOf('success') > -1) {
                setFormType('payment');
                setResponseStatus(true);
                openModalC();
                setModalInitialized(true);
            } else if (window.location.href.indexOf('failed') > -1) {
                setResponseStatus(false);
                openModalC();
                setModalInitialized(true);
            }
        }
    }, [setFormType, setResponseStatus, openModalC, modalInitialized]);

    return (
        <main className={styles.main}>
            <About/>
            <OurMission/>
            <CoreValues/>
            <Products id='products'/>
            <ServicesELS id='services'/>
            <Technologies id='technologies'/>
            <AutoServices/>
            <PlatformsTop id='platforms'/>
            <PlatformsBottom/>
            <ExpertsSlider/>
            <Reviews/>
            <Partners/>
            <Awards/>
            <ModalC/>
            <ModalServiceDescriptions/>
            <ModalServicesForms/>
        </main>
    );
}

export default Main;
